import $ from "jquery";
const websiteTicker = {
    methods: {
        handleTicker: function () {
            var windowWidth = $(window).width();
            var websiteTicker = $(".website-ticker#webTicker");
            var isWebsiteTickeronDesktop = websiteTicker.attr('data-hideDesktop');
            var isWebsiteTickerMobile = websiteTicker.attr('data-hideMobile');
            var headerSection = $(".header .header__wrapper .header--container");

            if (windowWidth < 768) {
                if (isWebsiteTickerMobile == "true") {
                    websiteTicker.hide();
                } else {
                    if (sessionStorage.getItem("tickerClosed")) {
                        websiteTicker.hide();
                        $(".header__wrapper").css("margin-bottom", "0px");
                    } else {
                        websiteTicker.show();
                        setTimeout(() => {
                            var headerHeight = headerSection.outerHeight(true);
                            var tickerHeight = websiteTicker.outerHeight(true);
                            $(".header__wrapper").css("margin-bottom", tickerHeight + "px");
                            websiteTicker.css({
                                position: "fixed",
                                top: headerHeight + "px",
                                width: "100%",
                                zIndex: "99"
                            });
                        }, 0);
                    }
                }

            } else {
                if (isWebsiteTickeronDesktop == "true") {
                    websiteTicker.hide();
                } else {
                    if (sessionStorage.getItem("tickerClosed")) {
                        websiteTicker.hide();
                    } else {
                        websiteTicker.show();
                    }
                }
            }
        },

        // R4 perf/correctness: bound once, separately from handleTicker() -
        // handleTicker() runs on every resize/orientationchange/load tick,
        // and previously re-bound this click handler every single time,
        // stacking a duplicate handler onto #closeTicker on every tick (plus
        // an extra one from the redundant page-ready + window "load" double
        // call on initial page load).
        bindCloseHandler: function () {
            $("#closeTicker").on("click", function () {
                var websiteTickerEl = $(".website-ticker#webTicker");
                websiteTickerEl.slideUp();
                sessionStorage.setItem("tickerClosed", "true");
                if ($(window).width() < 768) {
                    $(".header__wrapper").css("margin-bottom", "0px");
                }
            });
        },

        // Label in Name (WCAG 2.5.3) for links authored in the ticker text.
        // Authors sometimes give a link an aria-label that doesn't contain its
        // visible text, e.g. "Click Here" labelled "Assam Flood Claim Support":
        // the label replaces "Click Here", so a voice-control user saying
        // "click Click Here" gets nothing. Keep the label's wording as visually
        // hidden text after the visible text ("Click Here Assam Flood Claim
        // Support") and drop the aria-label; a title that only repeats the
        // label goes too (it's a tooltip that can't be dismissed, 1.4.13).
        // The proper fix is in the authored content: give the link
        // meaningful text and no aria-label.
        fixLinkLabels: function () {
            const words = (text) => (text || "").toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();
            $(".website-ticker .ticker-text a[aria-label]").each(function () {
                const label = this.getAttribute("aria-label").trim();
                const text = this.textContent;
                if (words(text).includes(words(label))) {
                    // Label adds nothing over the text: just let the text be the name
                    this.removeAttribute("aria-label");
                } else if (words(text)) {
                    $(this).append($('<span class="visually-hidden"></span>').text(` ${label}`));
                    this.removeAttribute("aria-label");
                }
                if (words(this.getAttribute("title")) === words(label)) {
                    this.removeAttribute("title");
                }
            });
        },

        applyResponsiveFont: function () {
            var windowWidth = $(window).width();
            var websiteTicker = $(".website-ticker#webTicker");
            var tickerText = websiteTicker.find(".ticker-text");

            if (windowWidth < 768) {
                var mobileFont = tickerText.data("mobile-font");
                if (mobileFont) {tickerText.css("font-size", mobileFont + "px");}
            } else if (windowWidth >= 768 && windowWidth < 1024) {
                var tabletFont = tickerText.data("tablet-font");
                if (tabletFont) {tickerText.css("font-size", tabletFont + "px");}
            } else {
                var desktopFont = tickerText.data("desktop-font");
                if (desktopFont) {tickerText.css("font-size", desktopFont + "px");}
            }
        }
    }
};

$(() => {
    if ($(".website-ticker").length) {
        websiteTicker.methods.handleTicker();
        websiteTicker.methods.applyResponsiveFont();
        websiteTicker.methods.bindCloseHandler();
        websiteTicker.methods.fixLinkLabels();
    }
});

// R4 perf: throttle to at most once per paint via rAF, matching the
// established pattern in header.js/quickLinks.js - this previously ran the
// full layout read/write work in handleTicker()/applyResponsiveFont()
// synchronously on every single resize/orientationchange tick.
let tickerResizeTicking = false;
$(window).on("load resize orientationchange", function () {
    if (!$(".website-ticker").length) {return;}
    if (tickerResizeTicking) {return;}
    tickerResizeTicking = true;
    window.requestAnimationFrame(function () {
        websiteTicker.methods.handleTicker();
        websiteTicker.methods.applyResponsiveFont();
        tickerResizeTicking = false;
    });
});
